const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Initial Consultation',
    description:
      'Reach out to our team and tell us about your facility\'s needs: roles, shifts, certifications, and timeline. We listen first, so we can match right.',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'Candidate Sourcing & Vetting',
    description:
      'We tap our network of credentialed professionals and paraprofessionals. Every candidate is screened for licensure, background, and experience before you ever see a name.',
  },
  {
    number: '03',
    icon: 'ri-user-follow-line',
    title: 'Placement & Onboarding',
    description:
      'We present qualified candidates for your review and handle the coordination. Once you approve, we manage onboarding logistics so your new staff member hits the floor ready to work.',
  },
  {
    number: '04',
    icon: 'ri-refresh-line',
    title: 'Ongoing Support',
    description:
      'Our relationship doesn\'t end at placement. Your dedicated account manager stays in contact to ensure the fit is working - and to respond fast if your needs change.',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-20 bg-[#1a3a3a] overflow-hidden">
      <div className="max-w-6xl mx-auto px-8 md:px-14">

        {/* Header */}
        <div className="flex items-start gap-5 mb-16">
          <div className="w-1 bg-[#c8a84b] self-stretch rounded-full shrink-0" style={{ minHeight: '50px' }} />
          <div>
            <p
              className="text-[#c8a84b] text-xs font-bold tracking-[0.3em] uppercase mb-2"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Our Process
            </p>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-white leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              How It Works
            </h2>
            <p
              className="text-white/60 text-base mt-3 max-w-xl leading-relaxed"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              From your first call to a fully placed. Here&apos;s exactly what to expect.
            </p>
          </div>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              <div className="relative z-10 rounded-lg p-7 h-full flex flex-col transition-all duration-300"
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(200,168,75,0.4)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
              >
                {/* Step number */}
                <div
                  className="text-[#c8a84b]/30 text-5xl font-extrabold leading-none mb-4 select-none"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#c8a84b]/15 border border-[#c8a84b]/30 mb-5">
                  <i className={`${step.icon} text-[#c8a84b] text-lg`} />
                </div>

                {/* Title */}
                <h3
                  className="text-white font-bold text-base mb-3 leading-snug"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {step.title}
                </h3>

                {/* Description */}
                <p
                  className="text-white/55 text-sm leading-relaxed flex-1"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-12 flex items-center gap-4 px-7 py-5 rounded-lg max-w-2xl" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
          <div className="w-10 h-10 flex items-center justify-center shrink-0">
            <i className="ri-time-line text-[#c8a84b] text-xl" />
          </div>
          <p
            className="text-white/55 text-sm leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <strong className="text-white/80">Fast turnaround is our standard.</strong> Most facilities receive qualified candidate profiles within 24&ndash;48 hours of their initial consultation.
          </p>
        </div>

      </div>
    </section>
  );
}
